import React from 'react';

export default ({ className, type, ...props }) => (
  <img alt="Logo" className={`${className} ${type}`} {...props} />
);
